import React from "react";
import { useTranslation } from 'react-i18next';
import Timestamp from "../components/Timestamp";
// Material UI Icons for categories
import CodeIcon from '@mui/icons-material/Code';
import WebIcon from '@mui/icons-material/Web';
import PsychologyIcon from '@mui/icons-material/Psychology';
import BuildIcon from '@mui/icons-material/Build';
import StorageIcon from '@mui/icons-material/Storage';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';

const TechnologySection = ({ title, children, icon: Icon }) => (
  <div className="mb-12">
    <div className="flex gap-3 items-center mb-4">
      {Icon && <Icon className="text-2xl text-primary" />}
      <h3 className="text-xl font-semibold sm:text-2xl">{title}</h3>
    </div>
    <div className="flex flex-wrap gap-4 justify-start mt-4">
      {children}
    </div>
  </div>
);

const TechnologyCard = ({ text, level }) => {
  return (
    <div className="relative group">
      <div className="px-4 py-3 rounded-lg border shadow-md transition-transform duration-300 bg-background border-secondary hover:scale-105">
        <div className="text-sm font-medium text-primary">{text}</div>
        {level && (
          <div className="mt-1 text-xs text-secondary">
            {level}
          </div>
        )}
      </div>
    </div>
  );
};

const TechnologiesSection = () => {
    const { t } = useTranslation();

  return (
    <section className="flex relative justify-center px-4 py-8 bg-grid-dots bg-dot-pattern sm:px-8" id="technologies">
      <div className="flex flex-col w-full max-w-6xl h-full">
        <div>
          <h2 className="text-3xl font-bold sm:text-4xl">{t("technologies")}</h2>
          <Timestamp />
        </div>

        {/* Languages Section */}
        <TechnologySection title={t("languages")} icon={CodeIcon}>
          <TechnologyCard text="TypeScript / JavaScript" level="Advanced" />
          <TechnologyCard text="Python" level="Advanced" />
          <TechnologyCard text="C" level="Intermediate" />
          <TechnologyCard text="C#" level="Intermediate" />
          <TechnologyCard text="C++" level="Intermediate" />
          <TechnologyCard text="Rust" level="Intermediate" />
          <TechnologyCard text="Solidity" level="Intermediate" />
        </TechnologySection>

        {/* Frameworks / Libraries Section */}
        <TechnologySection title={t("frameworks / libraries")} icon={WebIcon}>
          <TechnologyCard text="React.js" />
          <TechnologyCard text="Redux" />
          <TechnologyCard text="Node.js" />
          <TechnologyCard text="Express.js" />
          <TechnologyCard text="Tailwind CSS" />
          <TechnologyCard text="Material UI" />
          <TechnologyCard text="Chakra UI" />
        </TechnologySection>

        {/* Machine Learning Section */}
        <TechnologySection title={t("machine learning")} icon={PsychologyIcon}>
          <TechnologyCard text="TensorFlow" />
          <TechnologyCard text="PyTorch" />
          <TechnologyCard text="scikit-learn" />
        </TechnologySection>

        {/* Tools Section */}
        <TechnologySection title={t("tools")} icon={BuildIcon}>
          <TechnologyCard text="Docker" />
          <TechnologyCard text="Git" />
          <TechnologyCard text="JIRA" />
          <TechnologyCard text="Jenkins" />
          <TechnologyCard text="Figma" />
        </TechnologySection>

        {/* Databases Section */}
        <TechnologySection title={t("databases / cloud")} icon={StorageIcon}>
          <TechnologyCard text="MongoDB" />
          <TechnologyCard text="PostgreSQL" />
          <TechnologyCard text="Firebase" />
          <TechnologyCard text="AWS" />
          <TechnologyCard text="MySQL" />
        </TechnologySection>

        {/* Other Skills Section */}
        <TechnologySection title={t("other skills")} icon={IntegrationInstructionsIcon}>
          <TechnologyCard text="REST API Development" />
          <TechnologyCard text="CI/CD" />
          <TechnologyCard text="Linux Systems" />
        </TechnologySection>
      </div>
    </section>
  );
};

export default TechnologiesSection;